import {ContainerBinder} from '../../../IoC/ContainerBinder';
import {ModalController} from '../stores/ModalController/Modal.controller';
import {ModalService} from '../stores/ModalService/Modal.service';

export const bindModal = (container: ContainerBinder.Container) => {
  return new ContainerBinder(container)
    .bindSingleton(ModalService)
    .bind(ModalController)
    .done();
};
